// Import components
import { Tooltip } from 'components/elements';

// Import styles
import { StyledIconInfo } from './styles';

// Import types
import type { TValues, TKey } from 'types/libraries/i18n';

type Props = {
	i18nKey: TKey;
	namespace?: string;
	values?: TValues;
};

export const MoreInfoTooltip = (props: Props) => (
	<Tooltip {...props}>
		<StyledIconInfo />
	</Tooltip>
);
